import React from 'react';

// Amber "⚠ Outdated" pill for an alternative generated against an older version
// of the trip's brief (Rule A.3). Hint only; we never recompute. Same shape
// family as MainTag. `title` carries a short explanation on hover.

export interface StaleTagProps {
  /** Compact form (chip): icon only, no label, to save horizontal space. */
  compact?: boolean;
}

const StaleTag: React.FC<StaleTagProps> = ({ compact }) => (
  <span
    title="Based on older trip settings"
    style={{
      display: 'inline-flex',
      alignItems: 'center',
      gap: 3,
      padding: compact ? '2px 6px' : '2px 8px',
      borderRadius: 999,
      fontSize: 11,
      fontWeight: 700,
      letterSpacing: 0.4,
      color: '#8a5a00',
      background: '#fdf0d5',
      border: '1px solid rgba(138,90,0,0.25)',
      textTransform: 'uppercase',
      whiteSpace: 'nowrap',
    }}
  >
    ⚠{compact ? '' : ' Outdated'}
  </span>
);

export default StaleTag;
